module.exports = __webpack_public_path__ + "img/难再现.e48ae742.png";